// extracted by mini-css-extract-plugin
export default {"loader":"SmallLoader_loader__iPzno","rotation":"SmallLoader_rotation__FGRee"};